export default __webpack_public_path__ + "6c9339d9677e1500bff4aa2a46db1f55.png";